module.exports = __webpack_public_path__ + "img/tianmao-64db93e3.png";